import {computed, Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {SearchFilterMap, SearchIndexName} from '@models/search';
import {Filter, FilterSelection, FilterVisibility} from './filter';

@Injectable()
export class SearchTermFilter implements Filter<SearchIndexName> {
  key = 'q';
  label = 'Search';
  component = null; // This filter has no UI component
  visibility = FilterVisibility.NOONE;
  selectedValues: WritableSignal<string[]> = signal([]);
  selected: Signal<FilterSelection[]> = computed(() => this.selectedValues().map(value => ({label: value, value})));

  load(values: string[]): void {
    // Filter and keep only the first non-empty value
    const trimmedValues = values.filter(v => v && v.trim().length > 0);
    this.selectedValues.set(trimmedValues.slice(0, 1));
  }

  apply(filterBody: SearchFilterMap[SearchIndexName]): void {
    // This filter doesn't modify the search body; it's handled separately as global_search
  }

  remove(value: string): void {
    this.selectedValues.update(values => values.filter(v => v !== value));
  }
}
